import { render } from "./crm-profile.vue?vue&type=template&id=e0b3e74e"
import script from "./crm-profile.vue?vue&type=script&lang=js"
export * from "./crm-profile.vue?vue&type=script&lang=js"

import "./crm-profile.vue?vue&type=style&index=0&id=e0b3e74e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__